<template>
  <div class="info-container-temp" :id="scrollLink">
    <el-card :class="['box-card', infoTitle == ''?'no-title':'']" >
      <div slot="header" :class="['box-header', uploadButton?'flex-con':'']" v-if="infoTitle">
        <span class="box-header-title">{{infoTitle}}</span>
        
        <span class="box-header-warn" type="text" v-if="warnIcon"> 
          带<span class="red-point">*</span>&nbsp;为必填项
        </span>

        <el-button v-if="uploadButton" type="primary" size="mini" @click="chooseFile">上传附件</el-button>
        <input type="file" ref="fileInput" style="display: none;" accept=".pdf" @change="emitUploadClick">
      </div>
      <div class="detail-content">
        <template v-for="(item, index) in contentConfig">
          <div class="detail-one" :key="`${item.prop}-${index}`" v-if="item.display && item.display == 'false'?false:true">
            <div class="detail-top" v-if="item.title">
              <div class="detail-title">
                {{item.title}}
                <span v-if="item.tips" class="title-tips">{{item.tips}}</span>
              </div>
            </div>
            <div class="detail-content">
              <slot :name="item.prop"></slot>
            </div>
          </div>
        </template>
        <slot></slot>
      </div>
    </el-card>
  </div>
</template>
<script>

import {debounce} from "@/util/util";

let that=null
export default {
  name:'InfoContainer',
  data() {
    return {}
  },
  props: {
    /**
     * @param {String} infoTitle 页面信息块数组
     * @param {Array} contentConfig 页面信息块数组 [{title, prop, display}]
     * @param {Boolean} warnIcon 是否显示必填提示
     */
    infoTitle: {
      type: String,
      default: '项目信息'
    },
    contentConfig: {
      required: true,
      type: Array
    },
    warnIcon: {
      type: Boolean,
      default: false
    },
    // 默认跳转表示
    scrollLink: {
      type: String,
      default: 'infoHead'
    },
    // 是否需要修改流程名字
    isEditName: {
      type: Boolean,
      default: false
    },
    // 流程名字
    processInstanceName: {
      type: String,
      default: ''
    },
    // 是否需要上传附件
    uploadButton: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    that=this
   
  },
  beforeDestroy() {
    //组件销毁前，把定义的滞空
    that=null
  },
  methods:{
    setProcessInstanceName:debounce((value)=>{
      that.$emit("setProcessInstanceName",value)
    }, 1000),

    chooseFile() {
      this.$refs.fileInput.click()
    },

    emitUploadClick(event) {
      const selectedFile = event.target.files[0]
      if (selectedFile) {
        // 在这里处理选择的文件
        this.$emit('uploadClick', selectedFile)
      }
      
    },
  }

}
</script>
<style lang="scss">
.info-container-temp{
  .flex-con{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .box-card{
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 20px !important;
    border: 1px solid #e9e9e9 !important;
    .el-card__header{
      background-color: #fff !important;
    }    
    .red-point{
      color: red;
    }
    .box-header{

      background-color: #FFFFFF !important;
      padding: 10px 5px 10px 20px;
    }
    .box-header-title{
      color: rgb(51,51,51);
      font-weight: 600;
      font-size: 16px;
      display: flex;
      align-items: center;
      position: relative;
    }
    .box-header-title::before{
      content: '';
      width: 5px;
      background-color: #409EFF;
      height: 20px;
      position: absolute;
      left: -15px;
      top: 2px;
    }
    .box-header-warn{
      float: right;
      padding: 3px 0;
      color: #999;
      .red-point{
        color: red;
      }      
    }
    .detail-one{
      padding: 15px 50px !important;
      .detail-top{
        padding: 20px 5px;
        .detail-title{
          color: #666;
          font-weight: 700;
          font-size: 14px;
          line-height: 28px;
          position: relative;
          .title-tips{
            font-weight: 400;
            color: #666666;
            font-size: 13px;
          }
        }
        .detail-title::before{
          content: '';
          width: 5px;
          background-color: #409EFF;
          height: 18px;
          position: absolute;
          left: -12px;
          top: 5px;
        }
      }
    }

  }

  .no-title{
    .el-card__header{
      height: 0 !important;
      padding: 0 !important;
    }
  }    
} .process_instance_name {
  margin-left:20px;
  width:450px
  
}
</style>